import React from 'react';
import styles from './DashboardPage.module.scss';

export function DashboardPage(): React.ReactElement {
  return (
    <div className={styles.dashboardContainer}>
      <h1 className={styles.welcomeText}>Welcome to Admin Panel</h1>
    </div>
  );
}
